import { HStack } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const OptionStrategyGroupLegs = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = (): void => {
    sgwtWebAnalytics?.trackEvent(
      'Header',
      'user preferences, option tab, option strategy group legs',
      String(!userPreferences.optionStrategyGroupLegs),
    );
    updateUserPreferences({ ...userPreferences, optionStrategyGroupLegs: !userPreferences.optionStrategyGroupLegs });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="option-strategy-group-legs">
        <FormattedMessage id="userPreferences.label.optionStrategyGroupLegs" />
      </label>
      <HStack className="form-check-sm form-check-valid form-switch" data-e2e="optionStrategyGroupLegs">
        <input
          id="option-strategy-group-legs"
          className="form-check-input me-8px"
          type="checkbox"
          checked={userPreferences.optionStrategyGroupLegs}
          onChange={handleChange}
          data-e2e={'optionStrategyGroupLegs-checkbox'}
        />
        <span>
          <FormattedMessage id={`switchInput.${userPreferences.optionStrategyGroupLegs ? 'on' : 'off'}`} />
        </span>
      </HStack>
    </div>
  );
};

export default OptionStrategyGroupLegs;
